var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        position: "relative",
        width: "100%",
        "text-align": "center",
      },
    },
    [
      _c("v-progress-circular", {
        staticStyle: { margin: "0 auto", "margin-bottom": "30px" },
        attrs: { size: "64", indeterminate: "", color: "blue" },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "subheading unselectable loading-dots",
          staticStyle: { "text-align": "center" },
        },
        [
          _vm._v("\n    Loading " + _vm._s(_vm.resourceName) + "\n    "),
          _c("span", [_vm._v(".")]),
          _vm._v(" "),
          _c("span", [_vm._v(".")]),
          _vm._v(" "),
          _c("span", [_vm._v(".")]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }